import * as React from "react";
import type { SVGProps } from "react";
const SvgExpandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="expand_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M85.333 874.667A42.667 42.667 0 0 1 128 832h768a42.667 42.667 0 1 1 0 85.333H128a42.667 42.667 0 0 1-42.667-42.666zm292.48-213.334H896A42.667 42.667 0 1 0 896 576H377.813a149.675 149.675 0 0 0-100.48-100.48v-33.707a149.632 149.632 0 0 0 101.12-102.741l276.779-17.28a149.333 149.333 0 1 0-14.08-84.608l-264.064 16.512a149.419 149.419 0 0 0-291.755 44.97A149.376 149.376 0 0 0 192 441.814v33.707A149.419 149.419 0 0 0 234.667 768a149.419 149.419 0 0 0 143.146-106.667zm-79.146-42.666a64 64 0 1 1-128 0 64 64 0 0 1 128 0zm0-320.299v.512a64 64 0 1 1 0-.512zM789.333 192a64 64 0 1 1 0 128 64 64 0 0 1 0-128z"
    />
  </svg>
);
export default SvgExpandIcon;
